/**
 * Initial-based avatar with a stable color derived from the input.
 *
 *   <Avatar name="Kasun Perera" id="REG-001" />
 */
import React, { useMemo } from "react";
import { Avatar as MuiAvatar } from "@mui/material";

const PALETTE = [
    "#0ea5e9",
    "#6366f1",
    "#10b981",
    "#f59e0b",
    "#ef4444",
    "#3b82f6",
    "#8b5cf6",
    "#ec4899",
    "#14b8a6",
    "#f97316",
];

function hashString(input) {
    if (!input) return 0;
    let h = 0;
    for (let i = 0; i < input.length; i++) {
        h = (h << 5) - h + input.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h);
}

function getInitials(input) {
    if (!input) return "?";
    const parts = String(input).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function Avatar({ name, id, size = 40, sx, ...rest }) {
    const seed = id || name || "?";
    const initials = useMemo(() => getInitials(name || id), [name, id]);
    const color = useMemo(() => PALETTE[hashString(seed) % PALETTE.length], [seed]);
    return (
        <MuiAvatar
            sx={{
                bgcolor: color,
                color: "#fff",
                fontWeight: 600,
                fontSize: size * 0.4,
                width: size,
                height: size,
                ...sx,
            }}
            {...rest}
        >
            {initials}
        </MuiAvatar>
    );
}

export default Avatar;
